<!--
 * @Descripttion: 交建通扫描登陆组件
 * @version: 3.0
 * @Author: zhangfan
 * @email: 2207044692@qq.com
 * @Date: 2024-11-27 17:21:16
 * @LastEditors: zouxin
 * @LastEditTime: 2024-12-12 17:13:12
-->
<template>
  <div class="scan-code">
    <div class="qr-close">
      <div class="icon-close" @click="closeModal"><a-icon type="close" /></div>
    </div>
    <div class="qr-title">
      <div class="qr-logo"></div>
      {{ $t('base.jjtLogin') }}
    </div>
    <div class="qr-tips">{{ $t('base.pleaseScanQrcode') }}</div>
    <!-- <div class="qr-box">
      <div id="ercodeShow" class="ercode-box"></div>
    </div> -->
    <div v-show="isShow" id="ercodeShow" class="ercode-box"></div>
  </div>
</template>

<script>
import { scanLoginApi, approvalPublish, publishCommit } from '@/api/user'
import { getCCQrcode } from '@/api/auth'
import { getQueryStringWidthUrl } from '@/utils/util'
import { setToken } from './auth'
import { mapActions } from 'vuex'
import store from '@/store'
import { Modal } from 'ant-design-vue'
import { setComToken, transferComtoken } from '@/utils/comToken'

export default {
  name: 'ScanCode',
  data() {
    return {
      isShow: false,
      messageEventHandler: null,
    }
  },
  computed: {
    loginConfig() {
      return this.$store.getters.loginConfig
    },
  },
  methods: {
    ...mapActions({
      userInfo: 'user/info',
    }),
    closeModal() {
      window.removeEventListener('message', this.messageEventHandler)
      this.$emit('changeClose')
    },
    createJJTLogin() {
      const appType = process.env.VUE_APP_VITE_JJT_APP_TYPE
      getCCQrcode(appType)
        .then((res) => {
          if (!res.status) {
            const { data } = res
            // const url = `${process.env.VUE_APP_VITE_JJT_PATH}?appid=wl2c5e89d5c4&agentid=1002355&redirect_uri=https://bim.ccccltd.cn:31400/family/auth/sso/jjtLogin&state=vdclogin`
            const url = `${location.origin}${process.env.VUE_APP_VITE_JJT_PATH}?appid=${data.jjtAppId}&agentid=${data.jjtAgentId}&redirect_uri=${data.redirectUrl}&state=${data.state}`
            this.wwLogin(url)
          } else {
            this.closeModal()
          }
        })
        .catch(() => {
          this.closeModal()
        })
        .finally(() => {
          console.log('finally')
        })
    },
    wwLogin(originUrl) {
      const frame = document.createElement('iframe')
      frame.src = originUrl
      frame.className = 'qr-frame'
      frame.width = '260px'
      frame.height = '260px'
      const el = document.getElementById('ercodeShow')
      el.innerHTML = ''
      el.appendChild(frame)
      frame.onload = () => {
        if (frame.contentWindow?.postMessage && window.addEventListener) {
          this.isShow = true
          const frameDocument = frame.contentWindow.document
          frameDocument.getElementsByClassName('title')[0].setAttribute('style', 'display: none;')
          frameDocument.getElementsByClassName('info')[0].setAttribute('style', 'display: none;')
          // frameDocument.getElementsByClassName('qrcode')[0].setAttribute('style', 'width: 260px;')
          // frameDocument.getElementsByClassName('wrp_code')[0].setAttribute('style', 'margin-top: 0;')
          this.messageEventHandler = async (event) => {
            let host = process.env.VUE_APP_VITE_JJT_SCAN_PATH
            const hostArr = host.split(':')
            if (hostArr[1] === '80') [host] = [hostArr[0]]
            console.info(event, 'eventeventeventevent')
            const type = typeof event.data;
            if (type === 'string' && event.data.indexOf('code') > -1) {
              const code = getQueryStringWidthUrl('code', event.data) || ''
              if (code) {
                try {
                  const res = await scanLoginApi(code)
                  if (!res.data?.userId) return
                  const userId = 'aaaa_' + res.data?.userId
                  const resJJt = await approvalPublish(userId)
                  const loginSuccess = async () => {
                    store.commit('user/SET_IsShowNav', true)
                    this.$message.success('登录成功！')
                    setToken(res.data?.loginToken)
                    window.removeEventListener('message', this.messageEventHandler)
                    if (this.loginConfig.authType == 'center_auth') {
                      setComToken(res.data?.comToken)
                      //向中转页发送comToken
                      transferComtoken(this.loginConfig.schemaViewUrl, res.data?.comToken)
                      return
                    }
                    // 登录成功后跳转
                    const redirect = this.$route.query.redirect || '/'
                    this.$router.push(redirect)
                  }
                  if (resJJt?.result && resJJt?.result?.status === 1) {
                    loginSuccess()
                  } else if (resJJt?.result && resJJt?.result?.status != 1) {
                    this.closeModal()
                    this.$message.warning(this.$t('base.authorizationPending'))
                  } else if (!resJJt?.result) {
                    const data = {
                      applyAccount: userId,
                      accountType: this.$t('base.jjtAccountType'),
                    }
                    try {
                      let loginRes = await publishCommit(data)
                      if (loginRes.code === 200) {
                        loginSuccess()
                      } else {
                        console.error(loginRes.message)
                      }
                    } catch (error) {
                      if (error.result === false) {
                        let that = this
                        Modal.confirm({
                          title: this.$t('base.information'),
                          content: this.$t('base.jjtAccountNotExistCompanyCode'),
                          okText: this.$t('base.goSupplement'),
                          onOk: () => {
                            window.removeEventListener('message', that.messageEventHandler)
                            that.createJJTLogin()
                            // 跳转打开新页面
                            let companyUrl = `${process.env.VUE_APP_BIM_COMPANY}?token=${encodeURI(
                              res.data.loginToken
                            )}`
                            window.open(companyUrl, '_blank')
                          },
                          onCancel() {
                            window.removeEventListener('message', that.messageEventHandler)
                            that.createJJTLogin()
                          },
                        })
                      }
                    }
                  }
                } catch (err) {
                  window.removeEventListener('message', this.messageEventHandler)
                  this.createJJTLogin()
                }
              }
            }
          }
          window.addEventListener('message', this.messageEventHandler)
          frame.contentWindow?.postMessage('ask_usePostMessage', '*')
        }
      }
    },
  },
  mounted() {
    this.createJJTLogin()
  },
  beforeDestroy() {
    window.removeEventListener('message', this.messageEventHandler)
  },
}
</script>

<style lang="less" scoped>
.scan-code {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  // padding-bottom: 30px;

  .qr-title {
    display: flex;
    align-items: center;
    font-size: 24px;
    color: #ffffff;

    .qr-logo {
      width: 32px;
      height: 32px;
      margin-left: 16px;
      background-image: url('../../../assets/images/qr-logo.png');
      background-size: 100% 100%;
      margin-right: 13px;
    }
  }

  .qr-close {
    width: 100%;
    height: 30px;
    display: flex;
    align-items: right;
    justify-content: right;

    .icon-close {
      cursor: pointer;
    }
  }

  .qr-box {
    margin-top: 30px;
    width: 211px;
    // height: 211px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    border-radius: 5px 5px 5px 5px;
  }

  .ercode-box {
    // width: 180px;
    // height: 180px;
    width: 260px;
    height: 260px;
    position: relative;
    background-color: #ffffff;
    border-radius: 5px;
    // display: flex;
    // justify-content: center;
  }

  .qr-tips {
    margin: 16px 0;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #6b6b6b;
  }

  .qr-text {
    font-size: 12px;
    margin-top: 4px;
    color: rgb(var(--primary-6));
  }
}
</style>

<style>
.qr-frame {
  border: none;
}
</style>
